// extracted by mini-css-extract-plugin
export default {"control":"via_con_Bo1ch","methods":"via_met_1evg2","method":"via_met_oZpYH","active":"via_act_1hs42"};